/**
 * Centralized error handling utility
 */

export const handleError = (error, context = '', showToast = null) => {
  const timestamp = new Date().toLocaleTimeString();
  const errorMessage = error?.message || error?.toString() || 'Unknown error occurred';
  
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${timestamp}] ${context || 'Error'}:`, error);
  }

  // Prepare user-friendly message
  let userMessage = errorMessage;
  
  if (error?.response?.data?.message) {
    userMessage = error.response.data.message;
  } else if (error?.response?.status === 401) {
    userMessage = 'Unauthorized. Please log in again.';
  } else if (error?.response?.status === 403) {
    userMessage = 'You do not have permission to perform this action.';
  } else if (error?.response?.status === 404) {
    userMessage = 'Resource not found.';
  } else if (error?.response?.status === 500) {
    userMessage = 'Server error. Please try again later.';
  } else if (error?.response?.status === 0) {
    userMessage = 'Network error. Please check your connection.';
  }

  // Show toast notification if provided
  if (showToast) {
    showToast(userMessage, 'danger');
  }

  return userMessage;
};

export const logError = (error, context = '') => {
  const timestamp = new Date().toISOString();
  const errorLog = {
    timestamp,
    context,
    message: error?.message || 'Unknown error',
    stack: error?.stack,
  };

  if (process.env.NODE_ENV === 'development') {
    console.error('Error Log:', errorLog);
  }

  // In production, could send to error tracking service
  return errorLog;
};
